/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const VCF_RuleConstants = {
	RangeOperators: {
		and: '&&',
		none: 'none'
	},

	RULE_OPERATORS: {
		greaterThan: '>',
		greaterThanOrEqualTo: '>=',
		lessThan: '<',
		lessThanOrEqualTo: '<=',
		equalTo: '==',
		inTop: '>=',
		inBottom: '<=',
		missing: ''
	},

	CONDITION_TYPES: {
		GTE: 'GTE',
		LTE: 'LTE',
		GT: 'GT',
		LT: 'LT',
		ET: 'ET',
		IT: 'IT',
		IB: 'IB',
		MI: 'MI'
	},

	RULE_SCALES:{
		PERCENTAGE: '%',
		NUMERIC: '#'
	},

	RULE_TYPES: {
		THRESHOLD: 'threshold',
		RANGE: 'range'
	},

	RULE_STYLE_SHAPE: {
		upArrow: 'upArrow',
		rightArrow: 'rightArrow',
		downArrow: 'downArrow',
		upCaret: 'upCaret',
		dash: 'dash',
		downCaret: 'downCaret',
		checkmark: 'checkmark',
		warning: 'warning',
		xSymbol: 'xSymbol',
		circle: 'circle',
		triangle:'triangle',
		diamond: 'diamond',
		satisfied: 'satisfied',
		neutral: 'neutral',
		dissatisfied: 'dissatisfied',
		none: 'none'
	}
};

define([], function() {
	return VCF_RuleConstants;
});
